// extracted by mini-css-extract-plugin
export default {"best_way":"scrollway_best_way__gYVZQ","best_way_link":"scrollway_best_way_link__PbX2I","example":"scrollway_example__AIfJn"};